import api from "./api";

// Regular user auth - just enough for My Devices to compare
// its current version against.
export const getLatestFirmware = () => api.get("/firmware/latest");
